import { Card, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { MapViewerProvider } from "src/contexts/MapViewerContext";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import MapContainer from "src/pages/ant_landingpage/Unduh/MapContainer";
import BasemapContainer from "src/components/Map/BasemapContainer";
// import GeocodingSearchContainer from "src/components/Map/GeocodingSearchContainer";
import ScaleContainer from "src/components/Map/ScaleContainer";
import CoordinateContainer from "src/components/Map/CoordinateContainer";
import NavigationContainer from "src/components/Map/NavigationContainer";
import ZoomToolsContainer from "src/components/Map/ZoomToolsContainer";
import GpsToolsContainer from "src/components/Map/GpsToolsContainer";

import LayerStunting from "./LayerStunting";

const App = () => {
  const dataStunting = [
    { provinsi: "ACEH", jumlahBalita: 394129, stunting: 24603 },
    { provinsi: "SUMATERA UTARA", jumlahBalita: 946365, stunting: 156839 },
    { provinsi: "SUMATERA BARAT", jumlahBalita: 527080, stunting: 59408 },
    { provinsi: "RIAU", jumlahBalita: 642501, stunting: 68918 },
    { provinsi: "JAWA BARAT", jumlahBalita: 4976649, stunting: 1000156 },
  ];

  return (
    <MapViewerProvider>
      <Card
        title={
          <Breadcrumb
            items={[
              { title: "Beranda" },
              { title: <Link to="/webmap">Lihat Peta</Link> },
              { title: "Stunting" },
            ]}
          />
        }
        style={{ height: "100%" }}
        styles={{
          body: { backgroundColor: "#f0f2f5", height: "95%", padding: "0px" },
        }}
      >
        <MapContainer>
          {/* <GeocodingSearchContainer /> */}
          <ScaleContainer />
          <CoordinateContainer />
          <BasemapContainer />
          <NavigationContainer>
            <ZoomToolsContainer />
            <GpsToolsContainer />
          </NavigationContainer>
          <LayerStunting /> {/* Popup diatur sepenuhnya di LayerStunting */}
        </MapContainer>

        <div style={{ width: "100%", height: 300, marginTop: "20px" }}>
          <ResponsiveContainer>
            <BarChart
              data={dataStunting}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="provinsi" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="jumlahBalita" fill="#8884d8" />
              <Bar dataKey="stunting" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </MapViewerProvider>
  );
};

export default App;
